import { Controller } from "@hotwired/stimulus"

export default class OverviewRichTextTileController extends Controller {
  static targets = ["trixEditor"]

  trixEditorTargetConnected() {
    this.tile = this.trixEditorTarget.closest("turbo-frame")

    this.trixEditorTarget.toolbarElement.className =
      "absolute top-[40px] left-1/2 ml-[-144px] block"
  }

  editContent() {
    this.#enableTrixEditor()
    this.#showToolbar()
    this.#disableTileDragging()
  }

  viewContent() {
    this.#disableTrixEditor()
    this.#hideToolbar()
    this.#enableTileDragging()
  }

  #showToolbar() {
    this.trixEditorTarget.toolbarElement.style.display = "block"
  }

  #hideToolbar() {
    this.trixEditorTarget.toolbarElement.style.display = "none"
  }

  #disableTileDragging() {
    this.tile.setAttribute("draggable", false)
  }

  #enableTileDragging() {
    this.tile.setAttribute("draggable", true)
  }

  #enableTrixEditor() {
    this.trixEditorTarget.setAttribute("contentEditable", true)
  }

  #disableTrixEditor() {
    this.trixEditorTarget.setAttribute("contentEditable", false)
  }
}
